import styled, { css } from 'styled-components';

export const PlayerRoot = styled.div`
    height: 100%;
`;

export const PlayerBackdrop = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #002233;
    opacity: 0.6;
    transform: translate(-50%, -50%);
`;

export const PlayerStage = styled.div<{ $isFullScreen: boolean }>`
    ${({ $isFullScreen }) =>
        $isFullScreen
            ? css`
                  position: fixed;
                  top: 50%;
                  left: 50%;
                  z-index: 1050;
                  display: block;
                  width: 100vw;
                  height: 100vh;
                  max-width: 1300px;
                  max-height: 780px;
                  padding: 60px;
                  overflow: hidden;
                  outline: 0;
                  text-align: center;
                  transform: translate(-50%, -50%);
              `
            : css`
                  height: 100%;
                  text-align: right;
              `}
`;

export const PlayerLoading = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    small {
        margin-top: 10px;
        font-size: 0.875em;
        font-weight: 400;
    }
`;

export const PlayerCloseButton = styled.div`
    position: absolute;
    top: 15px;
    right: 15px;
`;

export const PlayerMedia = styled.div<{ $loaded: boolean; $isFullScreen: boolean }>`
    ${({ $loaded, $isFullScreen }) =>
        !$loaded
            ? css`
                  display: none;
              `
            : css`
                  height: 100%;

                  ${$isFullScreen &&
                  css`
                      position: relative;
                      display: inline-block;
                      width: calc(100% - 100px);
                      margin: 0 auto;

                      .video-js {
                          width: auto !important;
                          height: 80vh !important;
                      }
                  `}
              `}
`;
